import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';
export const oigStatusToIconMap = {
    missingFields: {
        icon: React.createElement(ErrorIcon, null),
        color: themeColors.accent.blue.base,
    },
    readyToVerify: {
        icon: React.createElement(ErrorIcon, null),
        color: themeColors.accent.blue.base,
    },
    pending: {
        icon: React.createElement(ErrorIcon, null),
        color: themeColors.accent.blue.base,
    },
    notVerified: {
        icon: React.createElement(CancelIcon, null),
        color: themeColors.accent.red.base,
    },
    verified: {
        icon: React.createElement(CheckCircleIcon, null),
        color: themeColors.accent.green.base,
    },
    statusNotDefined: {
        icon: React.createElement(ErrorIcon, null),
        color: themeColors.accent.red.base,
    },
};
